import ReactGA from 'react-ga';
import { getTenantFromUrl } from '../../utils/urlHelper';
import * as types from './types';

export default (state = {
  tenants: [],
  searchUsers: [],
  updateUserError: false,
  isFetchingUserTenants: false,
  isFetchingUser: false,
  isSearchingUsers: false,
  seenTutorials: null,
  user: null,
}, action = {}) => {
  switch (action.type) {
    case types.USER_TENANTS_REQUESTED:
      return {
        ...state,
        isFetchingUserTenants: true,
      };
    case types.USER_TENANTS_SUCCESS:
      return {
        ...state,
        isFetchingUserTenants: false,
        tenants: action.tenants,
      };
    case types.USER_TENANTS_ERROR:
    case types.USER_LEAVE_TENANT_ERROR:
      return {
        ...state,
        isFetchingUserTenants: false,
      };
    case types.SEARCH_USERS_REQUESTED:
      ReactGA.event({
        category: 'User',
        action: 'Search users',
      });
      return {
        ...state,
        isSearchingUsers: true,
      };
    case types.SEARCH_USERS_SUCCESS:
      return {
        ...state,
        isSearchingUsers: false,
        searchUsers: action.searchUsers,
      };
    case types.SEARCH_USERS_ERROR:
      return {
        ...state,
        isSearchingUsers: false,
      };
    case types.USER_LEAVE_TENANT_REQUESTED:
      ReactGA.event({
        category: 'User',
        action: 'Leave tenant',
        label: getTenantFromUrl(),
      });
      return {
        ...state,
        isFetchingUserTenants: true,
      };
    case types.USER_LEAVE_TENANT_SUCCESS:
      return {
        ...state,
        isFetchingUserTenants: false,
        leaveTenantResponse: action.leaveTenantResponse,
        tenants: state.tenants.filter((tenant) => tenant.name !== action.leaveTenantName),
      };
    case types.ME_REQUESTED:
      return {
        ...state,
        isFetchingUser: true,
      };
    case types.ME_SUCCESS:
      ReactGA.set({ userId: `${getTenantFromUrl()}_${action.user.email}` });
      return {
        ...state,
        isFetchingUser: false,
        user: action.user,
      };
    case types.ME_ERROR:
      return {
        ...state,
        isFetchingUser: false,
      };
    case types.UPDATE_USER_REQUESTED:
      ReactGA.event({
        category: 'User',
        action: 'Update user',
      });
      return {
        ...state,
        updateUserError: false,
        isFetchingUser: true,
      };
    case types.UPDATE_USER_SUCCESS:
      return {
        ...state,
        isFetchingUser: false,
        updateUserError: false,
        user: action.user,
      };
    case types.UPDATE_USER_ERROR:
      return {
        ...state,
        updateUserError: true,
        isFetchingUser: false,
      };
    case types.USER_TUTORIALS_REQUESTED:
      return { ...state };
    case types.USER_TUTORIALS_SUCCESS:
      return {
        ...state,
        seenTutorials: action.seenTutorials.tutorialsSeen,
      };
    case types.USER_TUTORIALS_ERROR:
    case types.UPDATE_USER_TUTORIALS_ERROR:
      return {
        ...state,
        seenTutorials: null,
      };
    case types.UPDATE_USER_TUTORIALS_REQUESTED:
      return { ...state };
    case types.UPDATE_USER_TUTORIALS_SUCCESS:
      return {
        ...state,
        seenTutorials: action.updatedSeenTutorials.tutorialsSeen,
      };
    default:
      return state;
  }
};
